import { AxiosInstance } from "axios";
import { createContext } from "react";
import { BoardApi } from "services/BoardApi";
import { BoardRoleApi } from "services/BoardRoleApi";
import { DownloadApi } from "services/DownloadApi";
import { ReportApi } from "services/ReportApi";
import { RunApi } from "services/RunApi";
import { RunParticipantApi } from "services/RunParticipantApi";
import { RunTopicApi } from "services/RunTopicApi";
import { UserApi } from "services/UserApi";
import { VotingApi } from "services/VotingApi";

export interface IApiContext {
  axios: AxiosInstance;
  downloadApi: DownloadApi;
  boardApi: BoardApi;
  boardRoleApi: BoardRoleApi;
  reportApi: ReportApi;
  runApi: RunApi;
  runParticipantApi: RunParticipantApi;
  runTopicApi: RunTopicApi;
  userApi: UserApi;
  votingApi: VotingApi;
}

export const ApiContext = createContext<IApiContext | undefined>(undefined);
